export default __webpack_public_path__ + "static/media/logo-mob.46610481.svg";